module.exports = __webpack_public_path__ + "img/logo.31af910c.svg";